import { useRef, useState } from "react";

const maxFileSize = 15 * 1024 * 1024;

const UploadArea = ({ files, setFiles }) => {
  const fileInputRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [exceedsLimit, setExceedsLimit] = useState(false);

  const handleFileClick = () => {
    fileInputRef.current?.click();
  };

  const isValidFileType = (file) => {
    const validTypes = [
      "image/jpeg",
      "image/jpg",
      "image/png",
      "application/pdf",
    ];
    return validTypes.includes(file.type);
  };

  const handleFileChange = (event) => {
    const newFiles = Array.from(event.target.files || []).filter(
      isValidFileType
    );
    const totalSize =
      files.reduce((acc, file) => acc + file.size, 0) +
      newFiles.reduce((acc, file) => acc + file.size, 0);

    if (totalSize > maxFileSize) {
      setExceedsLimit(true);
      return;
    }

    setExceedsLimit(false);
    setFiles([...files, ...newFiles]);
  };

  const handleDragEnter = (event) => {
    event.preventDefault();
    setIsDragging(true);
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleDragLeave = (event) => {
    event.preventDefault();
    setIsDragging(false);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    setIsDragging(false);
    const droppedFiles = Array.from(event.dataTransfer.files).filter(
      isValidFileType
    );
    const totalSize =
      files.reduce((acc, file) => acc + file.size, 0) +
      droppedFiles.reduce((acc, file) => acc + file.size, 0);

    if (totalSize > maxFileSize) {
      setExceedsLimit(true);
      return;
    }

    setExceedsLimit(false);
    setFiles([...files, ...droppedFiles]);
  };

  const handleRetry = () => {
    setExceedsLimit(false);
    setFiles([]);
    handleFileClick();
  };

  return (
    <div className="app-ai-quote-upload-area">
      <div
        className={`app-ai-quote-dnd-area ${
          isDragging ? "app-ai-quote-dragging" : ""
        } ${exceedsLimit ? "app-ai-quote-dnd-error-area" : ""}`}
        onDragEnter={handleDragEnter}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
      >
        {exceedsLimit ? (
          <div className={"app-ai-quote-dnd-error-icon"}>
            <img
              src="/order-now/icons/icon-error-dnd.svg"
              width={24}
              height={24}
              alt="Error icon"
            />
          </div>
        ) : isDragging ? (
          <div className="app-ai-quote-dnd-drop-icon">
            <img
              src="/order-now/icons/icon-arrow-top-dnd.svg"
              width={24}
              height={24}
              alt="Drop icon"
            />
          </div>
        ) : (
          <div className="app-ai-quote-dnd-upload-icon">
            <img
              src="/order-now/icons/icon-upload-dnd.svg"
              width={24}
              height={24}
              alt="Upload icon"
            />
          </div>
        )}
        {exceedsLimit ? (
          <div className="app-ai-quote-dnd-error-message">
            <p>
              Upload Failed! Please{" "}
              <button onClick={handleRetry}>try again</button>.
            </p>
            <p>15MB max files size</p>
          </div>
        ) : (
          <p>
            Drop files here to upload or
            <input
              type="file"
              ref={fileInputRef}
              accept=".png, .jpg, .jpeg, .pdf"
              multiple
              onChange={handleFileChange}
            />{" "}
            <span
              onClick={handleFileClick}
              className={isDragging ? "app-ai-quote-dnd-dragging" : ""}
            >
              Choose File
            </span>
          </p>
        )}
      </div>
      <div className="app-ai-quote-dnd-file-breadcrumbs">
        {files.map((file, index) => (
          <span key={index}>
            {file.name}
            <button
              onClick={() => {
                const curFiles = files.filter((_, i) => i !== index);
                setFiles(curFiles);

                if (fileInputRef && fileInputRef.current) {
                  fileInputRef.current.value = "";
                }
              }}
            >
              <img
                src="/order-now/icons/icon-close-dnd.svg"
                width={16}
                height={16}
                alt="Close"
              />
            </button>
          </span>
        ))}
      </div>
    </div>
  );
};

export default UploadArea;
